<template>
    <div class="OrderTracking" id="OrderTracking">
        <header-component></header-component>
        <div class="g-bg-gray">
          <div class="container-fluid g-py-100">
              <div class="row">
                  <div class="col-lg-10 offset-lg-1">
                      <div class="row">
                          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                              <p class="page-title">Track Orders & History</p>
                              <p class="text-center g-pt-40">
                                  To see the full order details, please click on the E-Order #. <br>To change, edit,
                                  or cancel a submitted order, please <a v-on:click="ShowModal()">click here</a> to contact us.
                              </p>
                              <order-tracking-filters @search="GetOrderTableData(0)" @reset="Reset()" @clicked="GetOrderTableData(0)" :OrderList="OrderList" :DispenseList.sync="DispenseList" :SearchObject="SearchObject" :PageValues="PageValues" :isDataLoading="isDataLoading" :searchValue='searchValue' :statusFilter='statusFilter' :statusString='statusString'></order-tracking-filters>
                              <order-tracking-table @sort="GetOrderTableData(0)" @delete="GetOrderTableData(0)" :SortValues="SortValues" :OrderList="OrderList" :DispenseList.sync="DispenseList" :PageValues="PageValues" :isDataLoading="isDataLoading" :MasterAccountType="MasterAccountType"></order-tracking-table>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
        <footer-component></footer-component>
    </div>
</template>
<script>
    import HeaderComponent from "@/components/shared/HeaderComponent";
    import FooterComponent from "@/components/shared/FooterComponent";
    import OrderTrackingTable from "@/components/portal/OrderTracking/OrderTrackingComponents/OrderTrackingTable";
    import OrderTrackingFilters from "@/components/portal/OrderTracking/OrderTrackingComponents/OrderTrackingFilters";
    import HelpForm from "@/components/shared/HelpForm";
    export default {
        components: {HeaderComponent, FooterComponent, OrderTrackingTable, OrderTrackingFilters, HelpForm},
        data(){
            return{
                DispenseList:null,
                OrderList:[],
                SalesforceId: null,
                PageValues:{
                    currentPage:1,
                    totalList:70,
                    itemsPerPage:20
                },
                isDataLoading:true,
                SearchObject:[
                                {RefinerType: 'Keyword', RefinerValue:''},
                                {RefinerType: "Date", RefinerValue: ''},
                                {RefinerType: "OrderStatus", RefinerValue: 'Pending|PendingApproval|InProcess|Shipped|Dispensed|Cancelled|PendingError|ExamOnly'}
                             ],
                SortValues:{
                    sortBy: 'default',
                    sortOrder:1
                },
                isModalShown: false,
                MasterAccountType:null,
                Account: {},
                searchValue: '',
                status:['Pending', 'PendingApproval', 'InProcess', 'Shipped', 'Dispensed' , 'Cancelled', 'PendingError', 'ExamOnly'],
                statusFilter:['Pending', 'PendingApproval', 'InProcess', 'Shipped','Dispensed' , 'Cancelled', 'PendingError', 'ExamOnly'],
                statusString :'Pending|PendingApproval|InProcess|Shipped|Dispensed|Cancelled|PendingError|ExamOnly'

            }
        },
        methods: {
            Reset(){
                this.SearchObject = [
                                        {RefinerType: 'Keyword', RefinerValue:''},
                                        {RefinerType: "Date", RefinerValue: ''},
                                        {RefinerType: "OrderStatus", RefinerValue: 'Pending|PendingApproval|InProcess|Shipped|Dispensed|Cancelled|PendingError|ExamOnly'}
                                    ];
                this.GetOrderTableData(1);
            },
            GetAccountValues(){
                var _this = this;
                this.isAccountLoading = true;
                axios.get('/Account/Self', {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                .then(function (response) {
                    _this.Account = response.data.raw;
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            GetOrderTableData(initialLoad){
                var _this = this;
                _this.isDataLoading = true;
                axios.post('/Order/ListValidOrders/'+ this.PageValues.currentPage + '/' + this.PageValues.itemsPerPage + '/' + this.SortValues.sortBy + '/' + this.SortValues.sortOrder + '/' + initialLoad, this.SearchObject, {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                .then(function (response) {

                    _this.OrderList = response.data.raw.list;
                    localStorage.setItem("orderTrackingList", JSON.stringify(_this.OrderList));
                    localStorage.setItem("resultCount", response.data.raw.resultCount.toString())
                    _this.PageValues.totalList = response.data.raw.resultCount;
                    _this.isDataLoading = false;

                    _this.DispenseList = _this.OrderList.slice();
                    _this.DispenseList.forEach(e => {
                         e.dispense = false
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    _this.$router.push({name: 'Error'});
                });
            },
            UpdateOrderStatus(){
                axios.get('/Order/UpdateOrderStatus', {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                .then(function(response){
                })
                .catch(function(error){
                    console.log(error);
                });
            },
            ShowModal() {
                document.body.classList.add("body-overflow");
                this.isModalShown = !this.isModalShown;
            },
            CloseModal() {
                this.isModalShown = false;
                document.body.classList.remove("body-overflow");
            }

        },
        created(){
            //   http://localhost:8080/Portal/OrderTracking?filter=true&PendingError=true&Search=Abraham
            let queryRoute = Object.keys(this.$route.query).reduce((c, k) => (c[k.toLowerCase()] = this.$route.query[k], c), {});
            this.searchValue = queryRoute.search || ''

            // if(queryRoute.filter && queryRoute.filter.toLowerCase() == 'true'){
                this.statusFilter = this.status.filter(e => {
                    let filter = queryRoute[e.toLowerCase()] || 'false'
                    if(filter.toLowerCase() == 'true'){
                        return true
                    } else {
                        return false
                    }
                })
                
                if(this.statusFilter.length > 0){
                    let find = ',';
                    let re = new RegExp(find, 'g');
                    this.statusString = this.statusFilter.toString().replace(re, '|');
                } else {
                    this.statusFilter = [...this.status]
                }
            // }
            this.SearchObject = [
                {RefinerType: 'Keyword', RefinerValue: this.searchValue},
                {RefinerType: "Date", RefinerValue: ''},
                {RefinerType: "OrderStatus", RefinerValue: this.statusString}
            ]

            this.MasterAccountType = localStorage.getItem("accountType");
            this.GetOrderTableData(0);
            this.UpdateOrderStatus();
            localStorage.setItem('is-active','track-order');
            this.GetAccountValues();


        }
    }
</script>



// WEBPACK FOOTER //
// OrderTracking.vue?4685401d